{
    "ApiKeys_AddMode": "deve criar um utilizador antes de poder criar uma chave de API.",
    "ApiKeys_Add_New": "Adicionar nova chave de API...",
    "ApiKeys_RevokeButton": "Revogar",
    "ApiKeys_RemoveButton": "remover",
    "ApiKeys_TableHeader_Name": "Nome",
    "ApiKeys_TableHeader_Expiry": "Termo",
    "ApiKeys_TableHeader_Created": "Criado",
    "ApiKeys_TableHeader_LastAccessed": "Último acesso",
    "ApiKeys_TableHeader_Title": "Chaves de API",
    "ApiKeys_Validations_Required": "Obrigatório",
    "ApiKeys_Name_Validations_MaxLength": "Comprimento máximo é 50",
    "ApiKeys_Revoke_ConfirmMessage": "Tem certeza de que deseja revogar esta chave de API?",
    "ApiKeys_Revoke_Confirm": "Confirmar",
    "ApiKeys_Revoke_Cancel": "Cancelar",
    "ApiKeys_Indefinite": "Nunca",
    "ApiKeys_Expired": "Expirado",
    "ApiKeys_Placeholder_Description": "Descrição",
    "ApiKeys_KeyDisplay_Title": "Token de acesso criado: \"{}\"",
    "ApiKeys_KeyDisplay_SubTitle": "Registe este token em algum lugar seguro, ele não poderá ser visualizado ou recuperado depois que fechar esta janela ou adicionar outra chave",
    "ApiKeys_Copy_Success": "Copiado para a área de transferência",
    "ApiKeys_Copy_Fail": "Falha ao copiar para a área de transferência",
    "ApiKeys_MaxAPIKeysReached": "atingiu o número máximo de chaves de API. Exclua uma chave existente antes de criar uma nova.",
    "NAME": "ApiKeys"
}